import React from "react"
import Caret from "../images/caret.svg"

const CaretIcon = () => <Caret />

export default CaretIcon
